import { faLinkedin, faFacebook } from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const StyledFooter = styled.footer`
  padding: 30px 0;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.obsidian};
  color: #fff;
  a {
    color: #fff;
  }
  hr {
    background-color: rgba(255, 255, 255, 0.5);
    height: 1px;
    border: 0;
    margin: 2rem 0;
  }
  .container {
    max-width: 1200px;
    margin: 0 auto;
  }
  .links {
    display: flex;
    justify-content: space-between;
    .social-links {
      svg {
        font-size: 18px;
      }
    }
    ul {
      display: block;
      list-style-type: none;
      margin: 0;
      padding: 0;
      &.pages {
        column-count: 2;
      }
      li {
        margin-bottom: 1rem;
      }
    }
  }
  @media only screen and (min-width: 650px) {
    .links {
      ul {
        display: flex;
        li {
          margin-bottom: 0;
          margin-right: 1.5rem;
          :last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
`

export default () => {
  const date = new Date()
  return (
    <StyledFooter>
      <div className="container">
        <div className="links">
          <ul className="pages">
            <li>
              <Link to="/#features">Features</Link>
            </li>
            <li>
              <Link to="/pricing">Pricing</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/blog">Blog</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
          <ul className="social-links">
            <li>
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/dealer9000"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
            </li>
          </ul>
        </div>
        <hr />
        <div>
          <p>
            <small>
              Copyright &copy; {date.getFullYear()} Automerce Limited (Company
              number 12265642) trading as Dealer 9000. All rights reserved.
            </small>
          </p>
          <Link to="/privacy">
            <small>Privacy Policy</small>
          </Link>
          {"  "}|{"  "}
          <Link to="/terms-of-service">
            <small>Terms of Service</small>
          </Link>
        </div>
      </div>
    </StyledFooter>
  )
}
